const parseMessages = (value: string) => value.split('\n').map((msg) => {
    const [role, content] = msg.split(': ');
    return {
        role: role.trim(),
        content: content.trim(),
    };
});

export default parseMessages;
